import { useState } from "react";
import { ChevronDown } from "lucide-react";
import faqs from "./data/faqs.json";

interface faqItemsType {
  question: string;
  answer: string;
  type: string;
}

const faqItems: faqItemsType[] = faqs;

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const rows: (typeof faqItems)[] = [];
  for (let i = 0; i < faqItems.length; i += 2) {
    rows.push(faqItems.slice(i, i + 2));
  }

  return (
    <div className="md:w-auto w-full mt-5 md:mx-25 flex flex-col gap-5 ">
      {rows.map((row, rowIndex) => (
        <div
          key={rowIndex}
          className="grid grid-cols-1 md:flex md:flex-row gap-5"
        >
          {row.map((item, colIndex) => {
            const index = rowIndex * 2 + colIndex;
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                dir="rtl" style={{ direction: "rtl" }}
                className={` place-self-center border-2 border-gray-300 transition-all duration-300 ${isOpen ? "rounded-3xl" : "rounded-4xl"
                  }
                ${item.type === "kangoro" ? "border-yellow-500" : ""}
                ${item.type === "bebras" ? "border-teal-400" : ""}
                ${item.type === "mutual" ? "border-l-yellow-500 border-r-teal-400 border-t-yellow-500 border-b-teal-400 md:w-full w-9/10" : "md:w-1/2 w-9/10"}
                `}
              >
                <div
                  onClick={() => toggle(index)}
                  className="px-3 flex flex-row items-center cursor-pointer h-15 justify-between"
                >
                  
                  <p className=" sm:text-md text-sm text-right" dir="rtl" style={{ direction: "rtl" }}>{item.question}</p>
                  <ChevronDown
                    className={` transition-transform duration-300 sm:w-8 w-5  ${isOpen ? "rotate-180" : ""
                      }`}
                  />
                </div>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                    }`}
                >
                  <div className="border-t border-gray-300 mx-5" />
                  <p
                    className="mx-5 my-4 text-gray-600 sm:text-sm text-xs leading-relaxed text-right"
                    style={{ direction: "rtl" }}
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
